"use client";

import { MonitorPlay, Trophy, UserCheck } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const features = [{
  title: "Artisanal Precision",
  description: "Every stone laid and every hedge trimmed reflects our commitment to architectural landscaping excellence.",
  icon: MonitorPlay
}, {
  title: "Seasonal Mastery",
  description: "From vibrant spring plantings to meticulous fall cleanups, we ensure your estate thrives year-round.",
  icon: Trophy
}, {
  title: "Dedicated Care",
  description: "Our expert team provides personalized maintenance plans tailored to the unique needs of your property.",
  icon: UserCheck
}];
export default function SpaceOpportunities() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="222323" id="the-campos-standard" className="py-24 dark bg-background relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/10 blur-[120px] rounded-lg pointer-events-none" />

      <div className="container mx-auto px-4 max-w-7xl relative z-10">
        <div className={`text-center mb-16 transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl md:text-5xl font-bold font-default text-foreground mb-6 tracking-tight">
            The Campos Standard
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto font-default">
            Experience the intersection of organic beauty and professional precision with our premium landscaping services.
          </p>
        </div>

        <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, i) => <div key={i} data-index={i} className={`transition-all duration-700 ease-out delay-[${i * 150}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <Card className="h-full bg-card/40 backdrop-blur-md border-border/20 shadow-md transition-all duration-300 ease-out hover:shadow-xl hover:-translate-y-2 group overflow-hidden relative rounded-lg">
                {}
                <div className="absolute -right-4 -bottom-4 text-8xl font-bold text-primary/5 select-none pointer-events-none font-default">
                  0{i + 1}
                </div>
                <div className="absolute inset-0 bg-gradient-to-br from-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" />
                
                <CardHeader className="pb-4 relative z-10">
                  <div className="w-16 h-16 rounded-lg bg-secondary/20 flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300 ease-out shadow-sm">
                    <feature.icon className="w-8 h-8 text-primary" strokeWidth={1} />
                  </div>
                  <CardTitle className="text-2xl font-bold font-default text-foreground tracking-tight">
                    {feature.title}
                  </CardTitle>
                  <Separator className="w-12 h-[1px] bg-primary/40 mt-5 transition-all duration-300 group-hover:w-16" />
                </CardHeader>
                <CardContent className="relative z-10">
                  <p className="text-muted-foreground text-base leading-relaxed font-default">
                    {feature.description}
                  </p>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}